module.exports = __webpack_public_path__ + "static/media/icon-pdf-logo.4dfb2503.png";